module.exports = {
      id: "Subtract-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#Subtract-icon",
      toString: function () {
        return this.url;
      }
    }